module.exports = {
    sys:{
        search: '查询',
        print: '打印',
        all: '全部',
        total: '共',
        record: '条',
        fullscreen: '全屏',
        exitFullscreen: '退出全屏',
        noData: '暂无数据',
        retry: '重试',
        notLogin: '未登录',
        toLogin: '去登录',
        notice: '提示',
        warning: '警告',
        error: '错误',
        clickTooFast: '点击太快啦，请稍后再试',
        saveSuccess: '保存成功',
        unlimited: '不限',
        errReason: '错误原因',
        test: '测试',
        reload: '刷新',
        username: '账号',
        sysError: '系统错误，请稍后再试',
        networkError: '网络错误，请稍后再试',
        download: '下载'
    },
    exam:{
        exam: '考试',
        simExam: '模拟卷',
        revisionBook: '错题本',
        noAnswer: '（未作答）',
        point: '分',
        selectPaper:'请选择试卷',
        selectKnowleagePoint: '请选择知识点',
        selectQuestionType: '请选择题型',
        inputKW: '请输入关键词',
        analysis: '解析',
        answer: '答案',
        wrong: '错误',
        right: '正确',
        answerArex: '作答区',
        viewAnswer: '查看答案',
        viewTemplate: '查看模板',
        viewTestCase: '查看用例',
        paperDesc: '试卷介绍',
        timeLimit: '限时',
        spendTime: '用时',
        remainingTime: '剩余时间',
        remainingHalf: '考试时间已过半',
        remaining5min: '考试还剩5分钟，请注意时间',
        remaining1min: '考试只剩1分钟，建议立即交卷',
        minute: '分钟',
        totalScore: '总分',
        gotScore: '得分',
        save: '保存',
        submit: '提交',
        submitProject: '保存作品',
        student: '考生',
        tips: '说明：',
        tips1:'1.蓝底色块：已做答状态',
        tips2:'2.白底色块：未作答状态',
        points: '分',
        questionSection: '（共{total}题，每题{questionScore}分，共{totalScore}分）',
        questionSeq: '第{index}题',
        questionIndex: '{index}.（{points}分）',
        modifyProject: '修改程序',
        startProject: '开始作答',
        viewQuestionStem: '查看题目',
        deviceTest: '设备检测',
        deviceRequirement: '设备要求',
        camera: '摄像头',
        cameraArea: '摄像头测试区域',
        photoArea: '手持准考证拍照区域',
        takePhoto: '拍照',
        cameraPass: '摄像头麦克风检测通过',
        cameraNotSupport: '不支持摄像头麦克风',
        cameraNotPass: '摄像头和麦克风开启失败，请检查设备',
        mic: '麦克风',
        requireMic: '请开启摄像头和麦克风后进入考试',
        requirePhoto: '请考前检录后进入考试',
        screenRecord: '录屏',
        screenRecorderArea: '录屏测试区域',
        requireScreenRecorder: '请开启录屏后进入考试',
        screenRecorderPass: '录屏开启成功',
        screenRecorderNotPass: '屏幕录制开启失败，请检查浏览器',
        autoProctor:'全程视频/语音监考中',
        broswerPass: '浏览器环境检测通过',
        broswerSuggest: '您的浏览器版本过低，请下载最新版谷歌浏览器',
        examConfirm: '考前确认',
        step1: '第一步 检测摄像头',
        step2: '第二步 考前检录',
        step3: '第三步 检测录屏功能',
        examEnsure: '考试须知',
        examEnsure1: '1、考试一旦开始无法暂停,请注意考试剩余时间',
        examEnsure2: '2、考试期间不得随意切出考试页面或退出全屏，系统会记录操作并提示',
        examEnsure3: '3、做完题目记得点击页面上方提交试卷',
        skipCheck: '您还未通过环境检测，是否直接进入考试？',
        enterExam: '进入测评',
        onGoing: '考试中',
        startTime: '开考时间',
        pleaseToLogin: '请登录后再打开本页面进行考试',
        ensureLeave: '确定要离开考试？',
        submitPaper: '交卷',
        reviewPaper: '批卷',
        submitSuccess: '提交成功',
        savePaper: '保存试卷',
        savePaperNow: '是否要保存试卷? ',
        undoCount: '你还有{undoCount}题未作答',
        undoReviewCount: '你还有{undoCount}题未批改',
        submitPaperNow: '是否要提交试卷? 交卷后考试结束！',
        examFinished: '考试结束',
        jumpoutNotice: '考试期间如需跳出页面验证程序，则系统会自动记录相关操作并提示，请注意操作',
        jumpoutBreak: '您的跳出页面操作已被系统记录，如非必要或不可控情况，请不要主动跳出页面过多，谢谢。',
        sureCloseEditor: '是否确定关闭编辑器?',
        sureSaveCode: '请确定代码已保存',
        keywords: '关键词：',
        gapWhich: '第',
        gapAnswer: '空答案：【',
        gapOr: ' 】或【',
        comment: '评语',
        submitTime: '交卷时间',
        submitTimes: '提交次数',
        continue: '继续考试',
        again: '再次考试',
        toExam: '去考试',
        onGoging: '考试中',
        saved: '已保存',
        submitted: '已提交',
        corrected: '已批改',
        pleaseInputUsername: '请输入账号',
        noPaper: '试卷将于开考时间准时开放，请耐心等待，及时刷新'
    }
}